import { render, staticRenderFns } from "./PresetRegimen.vue?vue&type=template&id=2a06b573&scoped=true"
import script from "./PresetRegimen.vue?vue&type=script&lang=js"
export * from "./PresetRegimen.vue?vue&type=script&lang=js"
import style0 from "./PresetRegimen.vue?vue&type=style&index=0&id=2a06b573&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06b573",
  null
  
)

export default component.exports